<template>
    <div>
        <div v-if="!showPay" >
            <div class="common_banner">
                <h3 class="title">享受全网超值价</h3>
                <p class="subtitle">专业级IP代理服务，百万IP任意切换</p>
            </div>
            <div class="container">
                <div class="container-item">
                    <h2 class="item_title">套餐选择</h2>
                    <div class="item_list" ref="item_list" >
                        <label v-if="getmeal">正在加载套餐数据...</label>
                        <label class="list_item" v-for="(item,index) in meal" :key="item.pc_price" v-on:click.stop.prevent="getmPakge($event,item.id,item.pc_price)" :class="[index == 0 ? 'click' : '' ]">
                            <div class="item-box">
                                <h4>{{item.type}}</h4>
                                <p class="money"><strong>{{item.pc_price}}</strong>元</p>
                                <p>原价{{item.original}}元</p>
                                <span class="offer" :style="{backgroundColor:item.bg_color}">{{item.offer}}</span>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="container-item user">
                    <h2 class="item_title">账户名称</h2>
                    <Input v-model="username" size="large" placeholder="请输入用户名" style="display:inline-block; width:260px" clearable @on-change="getuserdetail" />
                </div>
                <div class="container-item usernum">
                    <h2 class="item_title">在线数量</h2>
                    <!-- <input type="text" placeholder="请输入1-12在线数量"> -->
                    <!-- <input class="xxbtn" v-model="money_num" type="number" size="large" placeholder="请输入1-12在线数量" style="display:inline-block; width:260px;"/> -->

                    <InputNumber :max="100" :min="1" v-model="money_num" placeholder="请输入1-100在线数量" style=" width:260px;" :disabled="InputNumberStatus"></InputNumber>
                </div>
                <div class="container-item paymethods">
                    <h2 class="item_title">支付方式</h2>

                        <!-- <button class="click"><span class="iconfont">&#xe64e;</span> 支付宝支付</button>
                        <button><span class="iconfont">&#xe6d4;</span> 微信支付</button> -->
                        <button  v-for="item of this.pay" :key="item.value" :class="[item.value == 1 ? 'click' : '']" @click="getPayvalue(item.pay_method)">
                        <span class="iconfont" v-if="item.value == 1">&#xe64e;</span>
                        <span class="iconfont" v-if="item.value == 2">&#xe6d4;</span>
                            {{item.title}}
                        </button>

                </div>
                <div class="container-item sum">
                    <h2 class="item_title">账单合计</h2>
                    <h3>￥<span class="sum_money">{{money_num*money}}</span></h3>
                </div>
                <div class="container-item pay">
                    <h2 class="item_title"></h2>
                    <button class="payBtn" @click="subClick">确认支付</button>
                </div>
            </div>
            <!-- <button @click="getpay">支付</button> -->
        </div>
        <weixin :showPay="showPay" :payMoney="payMoney" :payImg="payImg" :payOrderid="payOrderid" @payback="payback"></weixin>
        <Modal v-model="modalStatus" width="100%">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>订单信息确认</span>
            </p>
            <div style="text-align:center">
                <p>您刚刚发起了微信支付</p>
                <p>是否已经完成订单支付</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="modal_loading" @click="confirmWechat">我已完成支付</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import axios from 'axios'
import doPost from "@/pages/Helper/XHR.js"
import Cookies from 'js-cookie'
import weixin from '@/pages/Buy/components/weixin'
export default {
    name: 'Buy',
    data () {
        return {
            username: '',
            meal: [],
            money_num: 1,
            getmeal: true,
            initmoney: '',
            product_id: '',
            money: 40,
            paymethod: 'alipay',
            UA: '',
            pay: [
                {
                    title: '支付宝支付',
                    value: 1,
                    pay_method: "alipay"
                },
                {
                    title: "微信支付",
                    value: 2,
                    pay_method: "weixin"
                }
            ],
            payvalue: 1,
            testorderid: '',
            showPay: false,
            payMoney: '',
            payImg : '',
            payOrderid: '',
            modalStatus: Cookies.get('modalStatus') || false,
            // modalStatus: true,
            modal_loading: false,
            InputNumberStatus: false,
        }
    },
    components: {weixin},
    computed: {
        sum_money () {
          if(typeof this.money_num == 'number'){
            return this.money_num * this.money
          }
        },
        init_money () {
            if(!Number(this.money_num)){
              return '您输入的值有误'
            }
            if(this.money == ""){
               return this.money_num * this.initmoney
            }else{
               return this.sum_money
            }
        }
    },
    watch: {
         money_num () {
            if(this.money_num > 100){
                this.$Message.warning('在线数量最大值为100');
            }else if(this.money_num < 1){
                this.$Message.warning('在线数量不能小于1');
            }else if(this.money_num == ''){
                this.$Message.warning('在线数量不能为空');
            }
        },
        username () {
            if(this.username != ""){
                document.querySelector(".payBtn").classList.add("click")
            }
        }
    },
    created () {
        this.$Loading.start()
         doPost (
            {action: 'all'},
            (res) => {
                this.$Loading.finish()
                res.meal.sort(function(x,y){
			        return	x.pc_price - y.pc_price
                })
                this.meal = res.meal
                this.initmoney = this.meal[0].pc_price
                this.product_id =  this.meal[0].id
                // for(let i=0; i<this.meal.length;i++){
                //     this.meal[i].original = parseInt(this.meal[i].pc_price * 1.2)
                //     this.meal[i].offer = "优惠" + Number(this.meal[i].original - this.meal[i].pc_price) + "元"
                // }                
                for(let i=0; i<this.meal.length;i++){
                    this.meal[i].original = res.meal[i].pc_original;
                    this.meal[i].offer = res.meal[i].pre_policies;
                    this.meal[i].bgColor = res.meal[i].bg_color;
                }

                this.getmeal = false
                 setTimeout(function(){
                    var dom = document.getElementsByClassName("list_item")
                    for(var i=0; i<dom.length; i++) {
                        dom[i].addEventListener("click",function() {
                            for(var j=0; j<dom.length; j++) {
                                dom[j].className = "list_item"
                            }
                            this.className = this.className + "  click"
                        })
                    }
                },100)
            }
        )
    },
    mounted () {
        var dom = document.querySelector(".paymethods").getElementsByTagName("button")
        for(var i=0;i<dom.length;i++){
            dom[i].addEventListener("click",function() {
                for(var j=0; j<dom.length; j++){
                    dom[j].className = ""
                }
                this.classList.add("click")
            })
        }
        this.macthUa()
        if(Cookies.get('username')){
            this.username = Cookies.get('username')
        }
    },
    methods: {
        getuserdetail () {
          doPost(
            {action: 'user_new_detail', username: this.username + '--'},
            (data) => {
              if(data.status == 200) {
                if(data.userinfo.deadtime){
                  this.money_num = data.userinfo.connect
                  this.InputNumberStatus = true
                  this.$Message.info({
                      content: `检测到您的在线数量为${this.money_num},在套餐使用时间内,如需新增更多在线数量,请联系客服`,
                      duration: 10
                  })
                }else{
                  this.money_num = data.userinfo.connect
                  this.InputNumberStatus = false
                }
              } else {
                 this.money_num = 1
                 this.InputNumberStatus = false
              }
            }
          )
        },
        //微信支付后父子通信
        payback () {
           this.showPay = false
        },
        //移动端微信支付 请求确认订单信息
        confirmWechat () {
            this.modal_loading = true
            let id = Cookies.get('id')
            doPost(
                {action:'check', orderid:id,},
                (data) => {
                    this.modal_loading = false
                    this.modalStatus = false
                    this.$Message.info({
                        content: data.detail,
                        duration: 60,
                        closable: true
                    })
                    Cookies.remove('modalStatus')
                })
        },
       //发起支付请求
       subClick () {
          //  console.log(`num ${this.money_num}`)
          //  console.log(`pay ${this.paymethod}`)
          //  console.log(`user ${this.username}`)
          //  console.log(`id ${this.product_id}`)
          //  console.log(`session ${localStorage.getItem("session")}`)
          //  console.log(`ua ${this.UA}`)
           var obj = {
               id: this.product_id,
               pay_method: this.paymethod,
               many: this.money_num,
               user: this.username,
               dev: 'pc',
               session: Cookies.get("session")
           }
           var obj = Object.assign({action: 'pay_info'},obj)
           for(let key in obj) {
               if(obj[key] == ""){
                  return
               }
           }
           this.$Loading.start()
           // 若在移动端 微信支付将启用新的接口
           if(obj.pay_method == 'weixin'){
               if(navigator.userAgent.match('iPhone') || navigator.userAgent.match('Android')){
                 let formData = new FormData()
                 let data = {
                     action: 'buy', id: this.product_id, pay_method: this.paymethod, many: this.money_num, user: this.username, dev: 'pc',int: '2'
                 }
                 for(var key in data) {
                   formData.append(key,data[key])
                 }
                 axios({
                   method: 'post',
                   url: '/h5.php',
                   data: formData
                 })
                 .then(res => {
                   let formData = new FormData()
                   formData.append('action',"pay")
                   formData.append('id',res.data.detail)
                   if(!res.data.status){
                     axios({
                       url: '/h5.php',
                       method: 'post',
                       data: formData
                     })
                     .then((resp) => {
                       if(resp.data.mweb_url){
                            this.$Loading.finish()
                            this.modalStatus = true
                            setTimeout(() => {
                                Cookies.set('modalStatus',this.modalStatus)
                                Cookies.set('id',res.data.detail)
                            },1500)
                            window.location.href = resp.data.mweb_url
                       }else{
                            this.$Loading.error()
                       }
                     })
                   }
                 })
                return
              }
           }
           // PC 端 获取订单ID
           doPost(
               obj,(res) => {
                   if(!res.status){
                      this.testorderid = res.orderid
                        // 请求支付
                        doPost(
                            {action: 'pay', orderid: this.testorderid, int: ''},
                            (res) => {
                                if(this.paymethod == 'alipay'){
                                    //支付宝直接返回form表单
                                    document.write(res)
                                }else{
                                    //显示微信页面 并动态填充数据
                                    this.showPay = true
                                    this.payMoney = res.money
                                    this.payImg = res.code_url
                                    // this.payImg = "https://cli.im/api/qrcode/code?text=" + res.code_url
                                    this.payOrderid =  this.testorderid
                                }
                                this.$Loading.finish()
                            }
                        )
                   }
               }
            )
       },
       getpay () {
           //测试 微信支付
            this.$Loading.start()
             doPost(
                {action: 'pay', orderid: this.testorderid, int: ''},
                (res) => {
                    if(this.paymethod == 'alipay'){
                        document.write(res)
                    }else{
                        this.showPay = true
                        this.payMoney = res.money
                        // this.payImg = "https://paysdk.weixin.qq.com/qrcode.php?data=" + res.code_url
                        this.payImg = res.code_url
                        this.payOrderid =  this.testorderid
                        this.$Loading.finish()
                    }
                }
            )
       },
       getmPakge (event,id,money) {
           event.stopPropagation()
           event.preventDefault()
           var dom = document.querySelector(".sum_money")
           var pay = document.querySelector(".payBtn")
           this.product_id = id
           this.money = money
           pay.style.background = "#43d2ab"
           pay.style.color = "#ffffff"
       },
       getPayvalue (pay) {
           this.paymethod = pay
       },
       macthUa () {
            var userAgents = navigator.userAgent
            if(userAgents.match(/Windows/g)){
                this.UA = "Windows"
            }else if(userAgents.match(/Android/g)){
                this.UA = "Android"
            }else{
                this.UA = "iPhone"
            }
       }
    }
}
</script>

<style lang="stylus" scoped>
.xxbtn
  border-radius 4px
  &::-webkit-input-placeholder
    color #9e9e9ead
.common_banner
    background-image url("~@/assets/img/buy_img/buy_banner.png")
.container
    width 1200px
    margin 30px auto 5px auto
.container .container-item:after
    content : ''
    display block
    height 30px
    clear both
.container .container-item .item_title
    width 76px
    height 36px
    margin-right 20px
    font-size 18px
    display inline-block
    float left
    line-height 36px
.container .container-item .item_list label
    float left
    width 160px
    height 180px
    display flex
    border 1px solid #cccccc
    margin-right 16px
    flex-direction column
    justify-content center
    text-align center
    border-radius 5px
.container .container-item .item_list label h4
    font-size 18px
.container .container-item .item_list label .money
    margin 10px 0px 25px 0px
.container .container-item .item_list label p strong
    font-size 36px
.container .container-item .item_list label p:nth-child(3)
    text-decoration line-through
    color #dddddd
.container .container-item input
    border 1px solid #cccccc
    width 260px
    height 36px
    padding 6px 10px
    vertical-align middle
.container .paymethods button
    width 120px
    height 36px
    background none
    border 1px solid #cccccc
    font-family MicrosoftYaHei
    font-size 14px
    color #333333
    letter-spacing 1px
.container .click
    background #2BD3A0
    color #f5f5f5
.container .paymethods .click
    background #2BD3A0
    color #f5f5f5
.container .sum h3
    font-family MicrosoftYaHei-Bold
    height 34px
    line-height 34px
    color #F5A623
.container .sum h3 span
    font-size 20px
.payBtn
    width 177px
    height 44px
    background #999999
    border-radius 100px
    font-family MicrosoftYaHei-Bold
    font-size 18px
    color #CCCCCC
    letter-spacing 1.05px
.item-box
    position relative
.offer
    position absolute
    right 0px
    top -39px
    border-radius 0px
    background #FF9800
    padding 2px 3px
    color #ffffff
@media screen and (max-width: 1200px)
    .container
        width 100%
    .container .container-item .item_title
        margin-left 10px
        float none
@media screen and (max-width: 456px)
    .container-item
        text-align center
        padding 0px 20px
    .container .container-item:after
        display none
    .container .container-item .item_list:after
        content ''
        display block
        clear both
        text-align center
    .container .container-item .item_title
        line-height 33px
        font-size 16px
        height 33px
    .container .container-item .item_list
        display inline-flex
        flex-wrap wrap
    .container .container-item .item_list label
        width 44%
        height 2.0rem
        margin .36rem auto
        margin-bottom .36rem
        display inline-block
    .container .container-item .item_title
        display block
    .container .sum h3 span
        font-size 36px
    .container .container-item .item_list label .money
        margin 10px
    .paymethods button
        display inline
        width 3rem
        height 100px
        text-align center
        font-size 14px
    .container .container-item .item_list label h4
        margin-top 10px
    .container .container-item .item_list label p strong
        font-size 30px
    .offer
        position absolute
        right 0px
        top -29px
        border-radius 0px
        background #FF9800
        padding 2px 3px
        color #ffffff
    .container .paymethods button
        margin 0 10px
    .payBtn
        margin-bottom 50px
    >>> .ivu-input
        margin 0 auto
        display block
    >>> .ivu-input-large
        height .76rem

</style>





// WEBPACK FOOTER //
// src/pages/Buy/Buy.vue